import Component from '../abstracts/Component';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';
import FiltersComponent from '../components/FiltersComponent';
import PriceRangeComponent from '../components/PriceRangeComponent';
import SaleRangeComponent from '../components/SaleRangeComponent';

export default class ActiveFiltersComponent extends Component {
  get SELECTORS() {
    return {
      activeFiltersContainer: '[data-active-filters]',
      selectedFilter: '[data-selected-filter]',
      selectedFilterNoPrice: '[data-selected-filter]:not([data-selected-price-range],[data-selected-sale-range])',
      activeFilter: '[data-selected-filter].active',
      priceFilter: '[data-selected-price-range]',
      saleRangeFilter: '[data-facet-code="saleRangePercentageFilter"]:not([data-selected-sale-range])',
      saleRangeActiveFilter: '[data-selected-sale-range]',
      activeInSaleFilter: '[data-in-sales-filter]',
      resetFilters: '[data-reset-filters]',
      activeFiltersCount: '[data-active-filters-count]',
      productsContainer: '[data-products-container]',
      close: '[data-remove-filter]',
      priceRangeLower: '.noUi-handle-lower',
      priceRangeUpper: '.noUi-handle-upper',
      activePriceFilterMin: '#currentSliderMinValue',
      activePriceFilterMax: '#currentSliderMaxValue',
      activeSaleRangeFilterMin: '#currentSaleRangeMinValue',
      activeSaleRangeFilterMax: '#currentSaleRangeMaxValue',
    }
  }

  get CLASSES() {
    return {
      active: 'active'
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.FiltersComponent = new FiltersComponent(htmlEl);
    this.PriceRangeComponent = new PriceRangeComponent(htmlEl);
    this.SaleRangeComponent = new SaleRangeComponent(htmlEl);
  }

  readDOM() {
    return {
      activeFiltersContainer: document.querySelector(this.SELECTORS.activeFiltersContainer),
      resetFilters: document.querySelector(this.SELECTORS.resetFilters),
      priceFilter: document.querySelector(this.SELECTORS.priceFilter),
      saleRangeFilters: document.querySelectorAll(this.SELECTORS.saleRangeFilter),
      saleRangeActiveFilters: this.$component.querySelectorAll(this.SELECTORS.saleRangeActiveFilter),
      activeInSaleFilter: this.$component.querySelector(this.SELECTORS.activeInSaleFilter)
    }
  }

  bindEvents() {
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({e, payload}) => {
      this.checkFiltersDisplayed();
    });

    $(document).ready(() => {
      this.checkFiltersDisplayed();
    });
  }

  checkFiltersDisplayed() {
    this.dom = this.readDOM();
    // get active filters from filters in page instead of response, to safe filters even for empty search
    const activeFiltersNoPrice = document.querySelectorAll(this.SELECTORS.selectedFilterNoPrice);
    activeFiltersNoPrice.forEach((input) => {
      const newFilter = document.querySelector("#" + CSS.escape(input.dataset.facetId));
      if (newFilter) {
        newFilter.checked ? input.classList.add(this.CLASSES.active) : input.classList.remove(this.CLASSES.active);
      } else {
        input.classList.remove(this.CLASSES.active);
      }
    });
    // price filter
    if (this.PriceRangeComponent.isSliderChanged(this.PriceRangeComponent.readDOM().rangeSlider)) {
      // priceFilter active, read current min, max value
      const currentMinValue =
        document.querySelector(this.SELECTORS.priceRangeLower).ariaValueNow;
      const currentMaxValue =
        document.querySelector(this.SELECTORS.priceRangeUpper).ariaValueNow;

      // set values in tag
      if (document.querySelector(this.SELECTORS.activePriceFilterMin) && document.querySelector(this.SELECTORS.activePriceFilterMax)) {
        document.querySelector(this.SELECTORS.activePriceFilterMin).innerHTML = parseInt(currentMinValue);
        document.querySelector(this.SELECTORS.activePriceFilterMax).innerHTML = parseInt(currentMaxValue);
      }
      // show price filter
      this.dom.priceFilter?.classList.add(this.CLASSES.active);
    } else {
      this.dom.priceFilter?.classList.remove(this.CLASSES.active);
    }
    // sale range filter
    if (this.dom.saleRangeFilters.length === 0) {
      this.dom.saleRangeActiveFilters.forEach((saleRange) => {saleRange.classList.remove(this.CLASSES.active)});
    } else {
      this.dom.saleRangeFilters.forEach((saleRange) => {
        const activeSaleFilter = this.$component.querySelector(this.SELECTORS.saleRangeActiveFilter + '[data-facet-id="' + CSS.escape(saleRange.id) + '"]');
        if (activeSaleFilter) {
          saleRange.checked ? activeSaleFilter.classList.add(this.CLASSES.active) : activeSaleFilter.classList.remove(this.CLASSES.active);
        }
      });
    }
    // inSales Filter (bool)
    if (this.$component.querySelector(this.SELECTORS.activeInSaleFilter)) {
      const inSalesFilter = document.querySelector(this.FiltersComponent.SELECTORS.inSaleFilter);
      if (inSalesFilter) {
        inSalesFilter.checked ? this.dom.activeInSaleFilter.classList.add(this.CLASSES.active) : this.dom.activeInSaleFilter.classList.remove(this.CLASSES.active);
      } else {
        this.dom.activeInSaleFilter.classList.remove(this.CLASSES.active);
      }
    }
    // newArrival filter not present for IB

    // reset filter show/hide
    const onlyActiveFilters = this.$component.querySelectorAll(this.SELECTORS.activeFilter);
    onlyActiveFilters.length > 0 ? this.dom.resetFilters.classList.add(this.CLASSES.active) : this.dom.resetFilters.classList.remove(this.CLASSES.active);
  }

  bindFilters() {
    const allActiveFilters = this.dom.activeFiltersContainer.querySelectorAll(this.SELECTORS.selectedFilter);
    const onlyActiveFilters = this.dom.activeFiltersContainer.querySelectorAll(this.SELECTORS.activeFilter);

    // remove filter from label event
    allActiveFilters.forEach(filter => {
      filter.querySelector(this.SELECTORS.close).addEventListener('click', () => {
        this.isReset = false;
        if (filter.dataset.selectedPriceRange !== undefined) {
          this.PriceRangeComponent.resetSlider();
        }

        if (filter.dataset.selectedSaleRange !== undefined) {
          this.SaleRangeComponent.resetInputs();
        }

        if (filter.dataset.selectedInSalesFilter !== undefined) {

        }
        if (filter.dataset.facetId !== '') {
          let filterId = '#' + filter.dataset.facetId;
          document.querySelector(filterId).checked = false;
          if(onlyActiveFilters.length === 1){
            this.isReset = true;
          }
        }

        this.applyChanges(this.isReset);
      });
    });

    this.dom.resetFilters.addEventListener('click', (e) => {
      this.FiltersComponent.resetFilters();
    });

  }

  applyChanges(isReset = false) {
    this.FiltersComponent.applyFilters(isReset);
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    if (!isMobile(MobileBreakpoint.Max1023)) {
      this.bindEvents();
      this.bindFilters();
    }
  }
}
